import { render, staticRenderFns } from "./form.component.vue?vue&type=template&id=4948262c"
import script from "./form.component.js?vue&type=script&lang=js&external"
export * from "./form.component.js?vue&type=script&lang=js&external"
import style0 from "./form.component.vue?vue&type=style&index=0&id=4948262c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports